import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import OhpDashboardContainer from './containers/OhpDashboardContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnNewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_ohp_new_per_status');
    return {
      label: 'New',
      total: _.get(totalStats, 'item.total_ohp_new', 0),
      // photo: ''
      list: [
        {
          label: 'Waiting for Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'PENDING LAB TEST', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Approved',
          value: _.get(data, 'APPROVED', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Printed',
          value: _.get(data, 'PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
      ],
    };
  };
  const returnRenewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_ohp_renew_per_status');
    return {
      label: 'Renew',
      total: _.get(totalStats, 'item.total_ohp_renew', 0),
      // photo: ''
      list: [
        {
          label: 'Waiting for Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Pending Lab Test',
          value: _.get(data, 'PENDING LAB TEST', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Approved',
          value: _.get(data, 'APPROVED', 0),
          borderClassName: 'pickup',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'received',
        },
        {
          label: 'Printed',
          value: _.get(data, 'PRINTED', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
      ],
    };
  };
  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnNewTransactionData()}
            className="mb-3"
          />
          <DashboardListCard data={returnRenewTransactionData()} />
        </div>
        <div className="col-8 pr-0">
          <OhpDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
